const normalize = value => typeof value === 'string' && value.trim().toLowerCase();

const isCaseTeamMember = (sourceCases, currentUser) => {
  const userIdentifiers = [
    currentUser.userEmailAddress,
    currentUser.userName,
  ].map(normalize).filter(Boolean);

  if (!userIdentifiers.length) return false;

  return sourceCases.some(({ attributes = {} }) => {
    const caseEmails = [
      attributes.wkrEmail,
      attributes.chfEmail,
      attributes.supEmail,
    ].map(normalize).filter(Boolean);

    return caseEmails.some(email => userIdentifiers.includes(email));
  });
};

export default isCaseTeamMember;
